<template>
	<button @click="goToPath">
		{{ title }}
	</button>
</template>
<script>
export default {
	name: 'YellowButton',
	props: {
		title: {
			type: String,
			default: ''
		},
		pathName: {
			type: String,
			default: ''
		}
	},
	methods: {
		goToPath() {
			this.$router.push({ name: this.pathName })
		}
	}
}
</script>

<style lang="stylus" scoped>
button {
    border: none;
	border-radius: 4px;
	color: black;
	background-color: #E5E41A;
	padding: 10px 40px;
	text-align: center;
	width: clamp(180px, 100vw, 418px);
	text-transform: uppercase;
	box-shadow: 3px 4px 2px rgba(229,228,26,0.75);
    transition: all 0.3s ease 0s;
    cursor: pointer;
    outline: none;
}
button:hover {
	box-shadow: 1px 2px 1px rgba(229,228,26,0.75);
	transform: translateY(-3px);
}
</style>
